<!-- @format -->

<div
	id="pdp-add-to-cart"
	class="hmf-display-flex hmf-justify-content-between hmf-flex-column">
	@if (isAttributeErrorUpdatedEnabled() && attributeErrorListString()) {
		<div class="hmf-mb-m">
			<hmf-alert-banner
				messageType="error"
				[messageTitle]="`Please select ${attributeErrorListString()} to continue`"></hmf-alert-banner>
		</div>
	}
	<pdp-feature-add-to-cart-button
		class="hmf-flex-grow hmf-display-flex hmf-justify-content-between hmf-mb-m"
		[ecode]="ecode()"></pdp-feature-add-to-cart-button>
	@if (favoritesEnabled()) {
		<pdp-add-to-cart-components-add-to-list-button
			class="hmf-mb-m"
			[ecode]="ecode()"
			[resolvedSku]="resolvedSkuPartNumber"
			[customAttributes]="customizedAttributes()"
			[isAuthenticated]="isAuthenticated"
			[listProductPersonalization]="listProductPersonalization"
			[isSingleSkuProduct]="isSingleSkuProduct()">
		</pdp-add-to-cart-components-add-to-list-button>
	}
	<pdp-feature-add-to-cart-alerts></pdp-feature-add-to-cart-alerts>
</div>
